import { bindRevealToggle } from './reveal-toggle';

var resetPinState = {
    pin: '',
    confirmPin: '',
    currentStep: 1,

    getControls: function () {
        var form = document.getElementById('resetPinForm');
        var step1 = document.getElementById('resetPinStep1');
        var step2 = document.getElementById('resetPinStep2');
        var submitButton = document.getElementById('resetPinSubmitButton');
        var pinBoxesStep1 = step1 ? step1.querySelectorAll('.mcp-pin-box') : [];
        var pinBoxesStep2 = step2 ? step2.querySelectorAll('.mcp-pin-box') : [];
        var showToggle1 = document.getElementById('pinShowToggle1');
        var showToggle2 = document.getElementById('pinShowToggle2');
        var mismatchError = document.getElementById('pinMismatchError');
        return {
            form: form,
            step1: step1,
            step2: step2,
            submitButton: submitButton,
            pinBoxesStep1: pinBoxesStep1,
            pinBoxesStep2: pinBoxesStep2,
            showToggle1: showToggle1,
            showToggle2: showToggle2,
            mismatchError: mismatchError
        };
    },

    init: function () {
        var controls = this.getControls();
        if (!controls.form) return;
        if (controls.form.getAttribute('data-reset-pin-initialized')) return;
        controls.form.setAttribute('data-reset-pin-initialized', 'true');

        this.pin = '';
        this.confirmPin = '';
        this.currentStep = 1;

        this.ensureCSRFToken(controls.form);
        this.initPinBoxes(controls.pinBoxesStep1, 1);
        this.initPinBoxes(controls.pinBoxesStep2, 2);
        bindRevealToggle(controls.showToggle1, controls.pinBoxesStep1);
        bindRevealToggle(controls.showToggle2, controls.pinBoxesStep2);
        this.initPinEncryption(controls);
        // Hide rules the sponsor's effective policy does not enforce, before the
        // member starts typing.
        if (window.pinValidation) {
            window.pinValidation.syncRuleList(
                window.pinValidation.readContextFromForm(controls.form)
            );
        }

        if (controls.pinBoxesStep1.length > 0) {
            controls.pinBoxesStep1[0].focus();
        }
    },

    ensureCSRFToken: function (form) {
        var tokenElem = document.getElementById('token');
        var tokenNameElem = document.getElementById('tokenName');
        if (!tokenElem || !tokenNameElem) return;

        var token = tokenElem.getAttribute('data-token');
        var tokenName = tokenNameElem.getAttribute('data-tokenName');
        if (!token || !tokenName) return;

        var existing = form.querySelector('input[name="' + tokenName + '"]');
        if (existing) {
            existing.value = token;
            return;
        }

        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = tokenName;
        input.value = token;
        form.appendChild(input);
    },

    initPinBoxes: function (boxes, step) {
        var self = this;
        for (var i = 0; i < boxes.length; i++) {
            (function (index) {
                boxes[index].addEventListener('input', function (e) {
                    var value = e.target.value.replace(/\D/g, '');
                    e.target.value = value;

                    if (value.length === 1 && index < boxes.length - 1) {
                        boxes[index + 1].focus();
                    }

                    self.updatePinValue(boxes, step);

                    if (step === 1 && self.pin.length === 4) {
                        self.advanceToStep2();
                    } else if (step === 2 && self.confirmPin.length === 4) {
                        self.attemptSubmit();
                    }
                });

                boxes[index].addEventListener('keydown', function (e) {
                    if (e.key === 'Backspace' && !e.target.value && index > 0) {
                        boxes[index - 1].focus();
                        boxes[index - 1].value = '';
                        self.updatePinValue(boxes, step);
                    }
                });

                boxes[index].addEventListener('paste', function (e) {
                    e.preventDefault();
                    var paste = (e.clipboardData || window.clipboardData)
                        .getData('text')
                        .replace(/\D/g, '');
                    for (
                        var j = 0;
                        j < paste.length && index + j < boxes.length;
                        j++
                    ) {
                        boxes[index + j].value = paste[j];
                    }
                    var lastFilledIndex = Math.min(
                        index + paste.length - 1,
                        boxes.length - 1
                    );
                    if (lastFilledIndex < boxes.length - 1) {
                        boxes[lastFilledIndex + 1].focus();
                    }
                    self.updatePinValue(boxes, step);

                    if (step === 1 && self.pin.length === 4) {
                        self.advanceToStep2();
                    } else if (step === 2 && self.confirmPin.length === 4) {
                        self.attemptSubmit();
                    }
                });
            })(i);
        }
    },

    updatePinValue: function (boxes, step) {
        var value = '';
        for (var i = 0; i < boxes.length; i++) {
            value += boxes[i].value;
        }
        if (step === 1) {
            this.pin = value;
        } else {
            this.confirmPin = value;
        }
    },

    advanceToStep2: function () {
        var controls = this.getControls();
        var ctx = window.pinValidation
            ? window.pinValidation.readContextFromForm(controls.form)
            : {};
        var result = window.pinValidation.validate(this.pin, ctx);

        if (!result.valid) {
            this.showPinValidationError(controls, result.errors);
            return;
        }

        this.clearPinValidationError(controls);
        this.currentStep = 2;
        controls.step1.hidden = true;
        controls.step2.hidden = false;
        if (controls.pinBoxesStep2.length > 0) {
            controls.pinBoxesStep2[0].focus();
        }
    },

    clearPinRuleHighlights: function () {
        var list = document.getElementById('resetPinRulesList');
        if (list) {
            var items = list.querySelectorAll('li');
            for (var i = 0; i < items.length; i++) {
                items[i].classList.remove('-invalid');
                items[i].removeAttribute('aria-invalid');
            }
        }
        var status = document.getElementById('resetPinRulesStatus');
        if (status) {
            status.textContent = '';
        }
    },

    highlightPinRules: function (errors) {
        this.clearPinRuleHighlights();
        var firstHighlighted = null;
        var messages = [];
        for (var e = 0; e < errors.length; e++) {
            var ruleItem = document.getElementById('pinRule' + errors[e]);
            if (ruleItem) {
                ruleItem.classList.add('-invalid');
                ruleItem.setAttribute('aria-invalid', 'true');
                var msg = ruleItem.getAttribute('data-error-message');
                if (msg) {
                    messages.push(msg);
                }
                if (!firstHighlighted) {
                    firstHighlighted = ruleItem;
                }
            }
        }
        var status = document.getElementById('resetPinRulesStatus');
        if (status && messages.length > 0) {
            status.textContent = messages.join('. ');
        }
        if (firstHighlighted) {
            firstHighlighted.scrollIntoView({
                block: 'nearest',
                behavior: 'smooth'
            });
        }
    },

    showPinValidationError: function (controls, errors) {
        this.highlightPinRules(errors);
        for (var i = 0; i < controls.pinBoxesStep1.length; i++) {
            controls.pinBoxesStep1[i].classList.add('is-invalid');
            controls.pinBoxesStep1[i].value = '';
        }
        this.pin = '';
        if (controls.pinBoxesStep1.length > 0) {
            controls.pinBoxesStep1[0].focus();
        }
    },

    clearPinValidationError: function (controls) {
        this.clearPinRuleHighlights();
        for (var i = 0; i < controls.pinBoxesStep1.length; i++) {
            controls.pinBoxesStep1[i].classList.remove('is-invalid');
        }
    },

    attemptSubmit: function () {
        var controls = this.getControls();

        if (this.pin !== this.confirmPin) {
            if (controls.mismatchError) {
                controls.mismatchError.hidden = false;
            }
            for (var i = 0; i < controls.pinBoxesStep2.length; i++) {
                controls.pinBoxesStep2[i].classList.add('is-invalid');
                controls.pinBoxesStep2[i].value = '';
            }
            this.confirmPin = '';
            if (controls.pinBoxesStep2.length > 0) {
                controls.pinBoxesStep2[0].focus();
            }
            return;
        }

        if (controls.mismatchError) {
            controls.mismatchError.hidden = true;
        }
        for (var i = 0; i < controls.pinBoxesStep2.length; i++) {
            controls.pinBoxesStep2[i].classList.remove('is-invalid');
        }

        document.getElementById('resetPinValue').value = this.pin;
        document.getElementById('resetConfirmPinValue').value = this.confirmPin;

        // Dismiss the mobile soft keyboard before submitting. The success/error
        // drawers are anchored to the bottom of the viewport; on iOS Safari the
        // keyboard is not reliably closed by the htmx swap removing the focused
        // input, so we must blur it explicitly while still inside the keystroke
        // gesture or it stays up and covers the drawer.
        this.dismissKeyboard(controls.pinBoxesStep2);

        if (controls.submitButton) {
            controls.submitButton.click();
        }
    },

    dismissKeyboard: function (boxes) {
        // Blurring document.activeElement covers the common case, but we also
        // blur every PIN box as a defensive fallback in case focus moved
        // elsewhere (e.g. the show/hide toggle) between the keystroke and here.
        // .blur() on an unfocused input is a harmless no-op.
        if (boxes) {
            for (var i = 0; i < boxes.length; i++) {
                boxes[i].blur();
            }
        }
        var active = document.activeElement;
        if (active && typeof active.blur === 'function') {
            active.blur();
        }
    },

    initPinEncryption: function (controls) {
        if (!controls.form || !controls.submitButton) return;

        var publicKey = controls.form.getAttribute('data-pin-public-key');
        if (!publicKey || typeof window.encryptPIN !== 'function') return;

        var self = this;
        controls.submitButton.addEventListener(
            'htmx:confirm',
            function (event) {
                var pin = self.pin;
                if (!pin || pin.length !== 4) return;

                var hiddenEncPIN = document.getElementById('resetEncryptedPIN');
                if (hiddenEncPIN && hiddenEncPIN.value) return;

                event.preventDefault();
                controls.submitButton.disabled = true;

                window
                    .encryptPIN(pin, publicKey)
                    .then(function (payload) {
                        var hiddenSymKey = document.getElementById(
                            'resetEncryptedSymmetricKey'
                        );
                        var hiddenChecksum =
                            document.getElementById('resetPinChecksum');

                        if (hiddenSymKey)
                            hiddenSymKey.value = payload.encryptedSymmetricKey;
                        if (hiddenEncPIN)
                            hiddenEncPIN.value = payload.encryptedPin;
                        if (hiddenChecksum)
                            hiddenChecksum.value = payload.checksum;

                        var resetPinValue =
                            document.getElementById('resetPinValue');
                        var resetConfirmPinValue = document.getElementById(
                            'resetConfirmPinValue'
                        );
                        if (resetPinValue) {
                            resetPinValue.removeAttribute('name');
                            resetPinValue.value = '';
                        }
                        if (resetConfirmPinValue) {
                            resetConfirmPinValue.removeAttribute('name');
                            resetConfirmPinValue.value = '';
                        }

                        event.detail.issueRequest();
                    })
                    .catch(function (err) {
                        console.error('PIN encryption failed:', err);
                        controls.submitButton.disabled = false;
                    });
            }
        );
    }
};

var resetPinVerifyState = {
    getControls: function () {
        var dobInput = document.getElementById('resetPinDOBInput');
        var cardLastFourInput = document.getElementById(
            'resetPinCardLastFourInput'
        );
        var ssnLastFourInput = document.getElementById(
            'resetPinSsnLastFourInput'
        );
        var verifyButton = document.getElementById('resetPinVerifyButton');

        return {
            dobInput: dobInput,
            cardLastFourInput: cardLastFourInput,
            ssnLastFourInput: ssnLastFourInput,
            verifyButton: verifyButton
        };
    },

    init: function () {
        var controls = this.getControls();
        if (!controls.verifyButton) return;
        if (controls.verifyButton.getAttribute('data-verify-initialized'))
            return;
        controls.verifyButton.setAttribute('data-verify-initialized', 'true');

        var self = this;

        if (controls.dobInput) {
            controls.dobInput.addEventListener('input', function (e) {
                self.formatDOB(e);
                self.validateAll(true);
            });
        }
        if (controls.cardLastFourInput) {
            controls.cardLastFourInput.addEventListener('input', function (e) {
                e.target.value = e.target.value.replace(/\D/g, '');
                self.validateAll();
            });
        }
        if (controls.ssnLastFourInput) {
            controls.ssnLastFourInput.addEventListener('input', function (e) {
                e.target.value = e.target.value.replace(/\D/g, '');
                self.validateAll();
            });
        }
        self.validateAll();
    },

    formatDOB: function (event) {
        var input = event.target.value.replace(/\D/g, '');
        if (input.length > 4) {
            input =
                input.slice(0, 2) +
                '/' +
                input.slice(2, 4) +
                '/' +
                input.slice(4);
        } else if (input.length > 2) {
            input = input.slice(0, 2) + '/' + input.slice(2);
        }
        event.target.value = input;
    },

    isValidDate: function (value) {
        if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return false;
        var parts = value.split('/');
        var month = parseInt(parts[0], 10);
        var day = parseInt(parts[1], 10);
        var year = parseInt(parts[2], 10);
        if (
            month < 1 ||
            month > 12 ||
            year < 1900 ||
            year > new Date().getFullYear()
        )
            return false;
        var date = new Date(year, month - 1, day);
        return (
            date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day
        );
    },

    validateAll: function (dobEdited) {
        var controls = this.getControls();
        var dobValid = true;
        var errorDiv = document.getElementById('dobError');

        if (controls.dobInput) {
            var value = controls.dobInput.value;
            var hasFullInput = /^\d{2}\/\d{2}\/\d{4}$/.test(value);
            dobValid = hasFullInput && this.isValidDate(value);
            if (hasFullInput && !dobValid && errorDiv) {
                errorDiv.textContent =
                    errorDiv.getAttribute('data-invalid-msg') ||
                    'Please enter a valid date of birth';
                controls.dobInput.classList.add('is-invalid');
                controls.dobInput.setAttribute('aria-invalid', 'true');
            } else if (
                errorDiv &&
                (dobEdited ||
                    !controls.dobInput.classList.contains('is-invalid'))
            ) {
                // Preserve a server-rendered required/invalid message during
                // initialization. Once the member edits DOB, client validation
                // owns this state and may clear or replace that message.
                errorDiv.textContent = '';
                controls.dobInput.classList.remove('is-invalid');
                controls.dobInput.removeAttribute('aria-invalid');
            }
        }

        var cardLastFourValid = true;
        if (controls.cardLastFourInput) {
            cardLastFourValid = /^\d{4}$/.test(
                controls.cardLastFourInput.value
            );
        }

        var ssnLastFourValid = true;
        if (controls.ssnLastFourInput) {
            ssnLastFourValid = /^\d{4}$/.test(controls.ssnLastFourInput.value);
        }

        controls.verifyButton.disabled =
            !dobValid || !cardLastFourValid || !ssnLastFourValid;
    }
};

window.addEventListener('load', function () {
    if (document.getElementById('resetPinForm')) {
        resetPinState.init();
    }
    if (document.getElementById('resetPinVerifyButton')) {
        resetPinVerifyState.init();
    }
});

document.addEventListener('htmx:afterSettle', function () {
    if (document.getElementById('resetPinForm')) {
        resetPinState.init();
    }
    if (document.getElementById('resetPinVerifyButton')) {
        resetPinVerifyState.init();
    }
});
